/** GA4 — bez GTM; ten sam ID co w konsoli Google Analytics. */
const GA_MEASUREMENT_ID = 'G-GTHGYF1RD3';

function injectGtag(): void {
  if (typeof document === 'undefined') return;
  if (document.querySelector(`script[data-ga4="${GA_MEASUREMENT_ID}"]`)) return;

  const external = document.createElement('script');
  external.async = true;
  external.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  external.setAttribute('data-ga4', GA_MEASUREMENT_ID);
  document.head.appendChild(external);

  const inline = document.createElement('script');
  inline.textContent = `
  window.dataLayer = window.dataLayer || [];
  function gtag(){dataLayer.push(arguments);}
  gtag('js', new Date());
  gtag('config', '${GA_MEASUREMENT_ID}');
`;
  document.head.appendChild(inline);
}

function scheduleAfterIdle(run: () => void): void {
  const kick = () => {
    if (typeof requestIdleCallback === 'function') {
      requestIdleCallback(run, { timeout: 4000 });
    } else {
      setTimeout(run, 0);
    }
  };
  if (document.readyState === 'complete') {
    kick();
  } else {
    window.addEventListener('load', () => kick(), { once: true });
  }
}

/** Ładuje gtag.js + config (poza pierwszym malowaniem — jak wcześniejszy GTM). */
export function loadGoogleTag(): void {
  scheduleAfterIdle(injectGtag);
}
